module.exports = __webpack_public_path__ + "static/img/Icono_Materiales_clase.5acd473d.svg";